const truthyFilter = (rows, columnIds, filterValue) => {
    const columnId = columnIds[0];
    return rows.filter((row) => {
        if (filterValue === undefined) {
            return true;
        }
        return filterValue ? !!row.values[columnId] : !row.values[columnId];
    });
};

export default truthyFilter;
